import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { HBDSchema } from "./HDBSchema";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { getCustomer, SUPPORTED_CUSTOMERS } from "../../../MainPage/VersionInfo";
import { cnFraMasterKey } from "../../CN/cnFraMasterKeys";
import { LocPrefixService } from "../../../LocationPrefixEditor/LocationPrefixService";
import { HBDMonthlySchema } from "./HBDMonthlySchema";
import { PillTextButton } from "../../../../libraries/GeneralButtons";
import { languageService } from "../../../../Language/language.service";
import SignalStorageBattery from "../../sims/ontario/signalStorageBattery";
const { sections } = HBDSchema;
const { monthlySections } = HBDMonthlySchema;

const masterKey = [
  { key: "OK", value: "Test complete equipment in satisfactory condition." },
  { key: "A/C", value: "Adjustments made / Test complete ‐ equipment in satisfactory condition." },
  {
    key: "A/R",
    value: "Adjustment Required.",
  },
  {
    key: "R/C",
    value: "Repair or replacement / Test complete ‐ equipment in satisfactory condition.",
  },
  { key: "N/A", value: "Test Not Applicable." },
];

class ReportView extends Component {
  constructor(props) {
    super(props);
    this.state = { showMonthly: false, pillText: "Show Month Details" };
  }

  render() {
    let { data } = this.props;

    let formSummary = {};

    data &&
      data.length > 0 &&
      data.forEach((item) => {
        const { month, summary } = item;
        !formSummary.year && (formSummary.year = item.year);
        !formSummary.milepost && (formSummary.milepost = item.fraHeaderInfo && item.fraHeaderInfo.mp);
        !formSummary.subdivision && (formSummary.subdivision = item.fraHeaderInfo && item.fraHeaderInfo.lineName);
        !formSummary.location && (formSummary.location = item.fraHeaderInfo && item.fraHeaderInfo.assetUnitId);

        for (let prop in summary) {
          if (summary.hasOwnProperty(prop)) {
            if (!formSummary[prop]) {
              formSummary[prop] = {};
            }

            formSummary[prop][month] = summary[prop];
          }
        }
      });

    return (
      <React.Fragment>
        <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
          <ReportTitleSection
            title="Record of HBD (Hot Box Detector) Inspections & Tests"
            subTitle="Relevé des Inspections de DBC (Détecteur de Boîtes Chaudes) et des Essais Effectués"
            {...this.props}
            fontSizeOverride={"35px"}
          />
          <span className="spacer"></span>

          <span className="spacer"></span>

          <table className="table-bordered" style={{ fontSize: "20px" }}>
            {sections.map((section) => {
              return <ReportTableSectionRenderer section={section} rowsData={formSummary} />;
            })}
          </table>

          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginTop: "-45px" }}>
            <div style={{ width: "50%" }}>
              <ReportFraConditionsMasterKey masterKey={getCustomer() === SUPPORTED_CUSTOMERS.CN ? cnFraMasterKey : masterKey} />
            </div>
            <div>
              <div>
                {" "}
                <strong>Note: </strong> See Monthly Details for Inspectors Names, Dates and Comments{" "}
              </div>
              <div className="no-print">
                <PillTextButton
                  title={languageService(this.state.pillText)}
                  onClick={() =>
                    this.setState({
                      showMonthly: !this.state.showMonthly,
                      pillText: this.state.showMonthly ? "Show Month Details" : "Hide Month Details",
                    })
                  }
                  style={{ fontSize: "14px", width: "max-content", height: "40px", float: "right" }}
                />
              </div>
            </div>
          </div>
        </div>

        {this.state.showMonthly &&
          data &&
          data.length > 0 &&
          data.map((item) => {
            let month = new Date(item.year, item.month - 1, 1);
            const summary = {
              year: item.year,
              monthEn: month.toLocaleString("en-US", { month: "long" }).toLocaleUpperCase(),
              monthFr: month.toLocaleString("fr-FR", { month: "long" }).toLocaleUpperCase(),
              milepost: item.fraHeaderInfo && item.fraHeaderInfo.mp,
              subdivision: item.fraHeaderInfo && item.fraHeaderInfo.lineName,
              location: item.fraHeaderInfo && item.fraHeaderInfo.assetUnitId,
              ...item.summary,
            };
            return (
              <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
                <ReportTitleSection
                  title="Record of HBD (Hot Box Detector) Inspections & Tests"
                  subTitle={`Month: ${month.toLocaleString("en-US", { month: "long" })}`}
                  fontSizeOverride={"35px"}
                />

                <table className="table-bordered" style={{ fontSize: "20px" }}>
                  {monthlySections.map((section) => {
                    return <ReportTableSectionRenderer section={section} rowsData={summary} />;
                  })}
                </table>

                <ReportFraConditionsMasterKey masterKey={getCustomer() === SUPPORTED_CUSTOMERS.CN ? cnFraMasterKey : masterKey} />
              </div>
            );
          })}
        {this.props.bReports || null}
      </React.Fragment>
    );
  }
}

const HDBReport = (props) => {
  const { reportData, isPreview, selectedAsset } = props;
  if (isPreview) {
    return <ReportView data={{}} />;
  }
  let reportsByMonth = ReportGroupingUtils.groupReportsByMonth(reportData);

  let batteryReportData = batteryCardsReports(reportData, selectedAsset);
  return reportsByMonth && reportsByMonth.length > 0 && <ReportView {...props} data={reportsByMonth} bReports={batteryReportData} />;
};

export default HDBReport;

function batteryCardsReports(reportData, asset) {
  /* 
  1- Group based on test codes
  2- Group each test code into circ field and table type. 
*/
  let testCodes = [{ code: "ONR_bu0a25_HBD", name: "Hotbox Battery Record", tableIds: ["tblBattbu0a25"] }];
  let modelsBatteriesReports = [];
  for (let batCode of testCodes) {
    let relevantData = reportData.filter((test) => test.testCode === batCode.code);
    for (let exist of relevantData) {
      for (let tblId of batCode.tableIds) {
        let tableData = exist.formData.find((field) => field.id === tblId);
        if (!tableData) continue;
        let dateObj = { date: exist.date };
        for (let formCont of tableData.value) {
          if (!formCont.removed && formCont.form) {
            let modelVal = formCont.form.find((field) => field && field.id === "circ");
            if (modelVal) {
              let formObj = { ...formCont, ...dateObj };
              let mIndex = modelsBatteriesReports.findIndex((bat) => bat.model === modelVal.value);
              if (mIndex > -1) {
                !modelsBatteriesReports[mIndex].value && (modelsBatteriesReports[mIndex].value = []);
                modelsBatteriesReports[mIndex].value.push(formObj);
              } else {
                modelsBatteriesReports.push({ value: [formObj], model: modelVal.value, name: batCode.name });
              }
            }
          }
        }
      }
    }
  }
  let batReports = modelsBatteriesReports.map((batteryReport, _i) => {
    return <SignalStorageBattery asset={asset} testData={batteryReport.value} name={batteryReport.name} noTitle={true} formData={"form"} />;
  });
  return batReports;
}



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/HBDReport/index.jsx